import React, { useEffect, useState } from 'react';
import ChatLayoutMobile from './components/ChatLayoutMobile';
import ChatLayoutDesktop from './components/ChatLayoutDesktop';
import PreChatForm from './components/PreChatForm';

function App() {
  const [isMobile, setIsMobile] = useState(null);
  const [chatStarted, setChatStarted] = useState(false);
  const [chatInfo, setChatInfo] = useState({ contact: '', subject: '', name: '' });

  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkScreen();
    window.addEventListener('resize', checkScreen);
    return () => window.removeEventListener('resize', checkScreen);
  }, []);

  const handleStartChat = (info) => {
    setChatInfo(info);
    setChatStarted(true);
  };

  if (isMobile === null) {
    return <p className="p-4 text-center text-gray-500">Loading chat interface...</p>;
  }

  if (!chatStarted) {
    return <PreChatForm onStartChat={handleStartChat} />;
  }

  return (
    <div className="min-h-screen bg-gray-100">
      {isMobile ? (
        <ChatLayoutMobile chatInfo={chatInfo} />
      ) : (
        <ChatLayoutDesktop chatInfo={chatInfo} />
      )}
    </div>
  );
}

export default App;
